function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, forwardRef } from "react";
import { Box } from "sprout-ui-primitives";
import styled, { css } from "styled-components";
import scrollbarSzie from "dom-helpers/scrollbarSize";
const ScrollContainerHiddenScrollWrapper = styled(Box)`
  ${({ $mount , $size  })=>$mount ? css`
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          margin-right: -${$size}px;
        ` : css`
          overflow: hidden;
        `}
`;
const ScrollContainerHiddenScroll = /*#__PURE__*/ forwardRef(function ScrollContainerHiddenScrollForwardRef(props, ref) {
    const { children  } = props, rest = _objectWithoutProperties(props, [
        "children"
    ]);
    const [size] = useState(()=>scrollbarSzie());
    const [mount, setMount] = useState(false);
    useEffect(()=>{
        setMount(true);
    }, []);
    return /*#__PURE__*/ _jsx(ScrollContainerHiddenScrollWrapper, _objectSpread({}, rest, {
        $mount: mount,
        $size: size,
        ref: ref,
        children: children
    }));
});
export default ScrollContainerHiddenScroll;
